// extracted by mini-css-extract-plugin
module.exports = {"panel":"PartySidePanels_panel__3eFon","rightPanel":"PartySidePanels_rightPanel__3DRb4","balloon":"PartySidePanels_balloon__2t3oB","leftPanel":"PartySidePanels_leftPanel__32kxB"};